import CheckCircle from "@mui/icons-material/CheckCircle";
import { FormControlLabel, Switch, Tooltip } from "@mui/material";
import dateformat from "dateformat";
import CalendarCheckFillIcon from "remixicon-react/CalendarEventFillIcon";
import { Button } from "$components";
import { DEFAULT_DATE_FORMAT } from "$utils/utils";
import DockyardStatusBadge from "../DockyardStatusBadge";
import { useStyles } from "../styles";
import { DockyardDetailsLogic } from "../types";

type DockyardHeaderProps = Pick<
  DockyardDetailsLogic,
  | "dockyard"
  | "isDockyardDisabled"
  | "isDone"
  | "canToggleDockyard"
  | "isContributorUser"
  | "isClientUser"
  | "canEdit"
  | "edbList"
  | "hasOrders"
  | "hasEdbLeft"
  | "handleSwitchToggle"
  | "setModalDeleteOpen"
  | "setModal"
  | "isTogglePending"
>;

export default function DockyardHeader({
  dockyard,
  isDockyardDisabled,
  isDone,
  canToggleDockyard,
  isContributorUser,
  isClientUser,
  canEdit,
  edbList,
  hasOrders,
  hasEdbLeft,
  handleSwitchToggle,
  setModalDeleteOpen,
  setModal,
  isTogglePending,
}: DockyardHeaderProps) {
  const classes = useStyles();

  return (
    <div
      style={{
        display: "flex",
        marginLeft: 18,
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div className={classes.customHeader}>
        <div className={classes.calendar}>
          <CalendarCheckFillIcon className={classes.calendarIcon} />
          Créé le{" "}
          {(dockyard as any)?.createdAt &&
            dateformat(
              new Date((dockyard as any)?.createdAt),
              DEFAULT_DATE_FORMAT
            )}
        </div>
        <div className={classes.statusBadge}>
          <DockyardStatusBadge status={dockyard?.status} />
        </div>
        <FormControlLabel
          className={classes.switchButton}
          control={
            <Switch
              checked={!isDockyardDisabled}
              onChange={handleSwitchToggle}
              name="activeCompany"
              color="primary"
            />
          }
          disabled={
            isDone || isContributorUser || !canToggleDockyard || isTogglePending
          }
          label="Chantier actif"
        />
        <div />
      </div>
      <Tooltip
        title={
          isDone
            ? "Vous ne pouvez pas supprimer un chantier terminé"
            : (edbList?.data?.length || 0) > 0 || hasOrders === true
              ? "Vous ne pouvez pas supprimer ce chantier car il a des expressions de besoin existantes"
              : ""
        }
      >
        <Button
          style={{ marginRight: 40, marginTop: 20 }}
          onClick={() => setModalDeleteOpen(true)}
          className={[
            classes.buttonDelete,
            (edbList?.data?.length || 0) > 0 || hasOrders === true || isDone
              ? "disabled"
              : "",
          ].join(" ")}
          disabled={(isContributorUser && !isClientUser) || !canEdit || isDone}
        >
          Supprimer le chantier
        </Button>
      </Tooltip>
      <Button
        onClick={() => setModal(true)}
        className={[
          classes.BtnDone,
          isDone ? "disabled" : hasEdbLeft ? "disabled" : "",
        ].join(" ")}
        disabled={(isContributorUser && !isClientUser) || !canEdit}
      >
        <CheckCircle style={{ marginRight: "5px" }} />
        {!isDone
          ? "Terminer mon chantier"
          : `Terminé le ${dateformat(
              new Date(dockyard?.updateAt || "").toDateString(),
              DEFAULT_DATE_FORMAT
            )}`}
      </Button>
    </div>
  );
}
